var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 307.302 307.302",
    style: {
      enableBackground: "new 0 0 307.302 307.302"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70.318,
    y: 149.942,
    style: {
      fill: "#C39F73"
    },
    width: 6.08,
    height: 16.506
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.904,
    y: 149.942,
    style: {
      fill: "#C39F73"
    },
    width: 6.08,
    height: 16.506
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9B07F"
    },
    d: "M231.692,136.741c0-7.997-34.94-14.479-78.041-14.479s-78.041,6.482-78.041,14.479v50.736v105.346 c0,7.997,34.94,14.479,78.041,14.479s78.041-6.483,78.041-14.479V187.476V136.741L231.692,136.741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C39F73"
    },
    d: "M153.651,122.261c-43.101,0-78.041,6.482-78.041,14.479v50.736v105.346 c0,7.997,34.94,14.479,78.041,14.479V122.261z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#956958"
    },
    cx: 153.651,
    cy: 137.677,
    rx: 62.5,
    ry: 8.297
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7C5849"
    },
    d: "M153.651,145.974c-34.518,0-62.5-3.715-62.5-8.297s27.982-8.297,62.5-8.297V145.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#956958"
    },
    d: "M235.745,5.319H71.557l0,0c-6.536,0-11.834,5.298-11.834,11.834v140.52 c0,6.536,5.298,11.834,11.834,11.834l0,0V20.332c0-1.756,1.423-3.179,3.179-3.179h157.83c1.756,0,3.179,1.423,3.179,3.179v149.175 l0,0c6.536,0,11.834-5.298,11.834-11.834V17.152C247.578,10.617,242.28,5.319,235.745,5.319L235.745,5.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7C5849"
    },
    d: "M152.651,5.319H71.557c-6.536,0-11.833,5.298-11.833,11.834v140.52 c0,6.535,5.298,11.833,11.833,11.833V20.332c0-1.756,1.423-3.179,3.179-3.179h77.915V5.319z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#956958"
    },
    d: "M221.225,156.182c-13.496,4.327-38.693,7.24-67.574,7.24s-54.079-2.913-67.575-7.24 c-6.645-2.13-10.467-4.601-10.467-7.24v16.533c0,2.638,3.822,5.109,10.467,7.24c13.496,4.327,38.693,7.24,67.575,7.24 c28.881,0,54.079-2.913,67.574-7.24c6.645-2.13,10.466-4.601,10.466-7.24v-16.533C231.692,151.58,227.87,154.052,221.225,156.182z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7C5849"
    },
    d: "M153.651,163.421c-28.881,0-54.079-2.913-67.575-7.24c-6.645-2.13-10.467-4.601-10.467-7.24v16.533 c0,2.638,3.822,5.109,10.467,7.24c13.496,4.327,38.693,7.24,67.575,7.24V163.421z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9C890"
    },
    d: "M153.651,0c-2.938,0-5.319,2.381-5.319,5.319v124.093v16.531c1.755,0.02,3.525,0.032,5.319,0.032 s3.564-0.012,5.319-0.032v-16.531V5.319C158.97,2.381,156.588,0,153.651,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9B07F"
    },
    d: "M153.651,0c-2.938,0-5.319,2.381-5.319,5.319v124.093v16.531c1.755,0.02,3.525,0.032,5.319,0.032V0 z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWell);
export default __webpack_public_path__ + "static/media/well.bac1928695a676773991437f12db37b1.svg";
export { ForwardRef as ReactComponent };